import React, { createRef } from "react";
import useStyles from "./styles";
import CloseIcon from "@material-ui/icons/Close";

import { Grid, Dialog, IconButton, Button } from "@material-ui/core";
import { Images } from "config/images";

function HeaderDialog({ handleWatchOrder }) {
	const classes = useStyles();
	return (
		<IconButton
			aria-label="close"
			onClick={handleWatchOrder}
			classes={{ root: classes.btnClose }}
		>
			<CloseIcon />
		</IconButton>
	);
}

function BodyDialog({ open }) {
	const classes = useStyles();
	return (
		<React.Fragment>
			<img
				src={!open.isError ? Images.icGiftSuccess : Images.icGiftError}
				alt={!open.isError ? "icGiftSuccess" : "icGiftError"}
				width={72}
			/>
			<Grid classes={{ root: classes.title }}>
				{!open.isError ? "Đặt hàng thành công" : "Đặt hàng thất bại"}
			</Grid>
		</React.Fragment>
	);
}

function FooterDialog({ open, handleTryAgain, handleHome, handleWatchOrder }) {
	const classes = useStyles();
	return open.isError ? (
		<React.Fragment>
			<Grid classes={{ root: classes.driver }} />
			<Grid
				classes={{ root: classes.btnSubmit }}
				onClick={() => handleTryAgain()}
			>
				Thử lại
			</Grid>
		</React.Fragment>
	) : (
		<Grid
			container
			spacing={1}
			classes={{ root: classes.bodyFooter }}
			justifyContent="center"
		>
			<Grid item xs={6}>
				<Button
					classes={{ root: classes.btnCancel }}
					onClick={() => handleHome()}
				>
					Trang chủ
				</Button>
			</Grid>
			<Grid item xs={6}>
				<Button
					classes={{
						root: classes.btnConfirm
					}}
					onClick={() => handleWatchOrder()}
				>
					Xem đơn hàng
				</Button>
			</Grid>
		</Grid>
	);
}

const DialogInformationTP = props => {
	const classes = useStyles();
	const { handleWatchOrder, open, handleTryAgain, handleHome } = props;
	const nodeRef = createRef();

	return (
		<Dialog
			onClose={() => handleWatchOrder()}
			aria-labelledby="customized-dialog-title"
			open={open.isOpen}
			ref={nodeRef}
			fullWidth
			classes={{
				paper: classes.customDialogSecond
			}}
		>
			<Grid style={{ position: "relative" }}>
				<HeaderDialog handleWatchOrder={handleWatchOrder} />
				<Grid classes={{ root: classes.body }}>
					<BodyDialog open={open} />
					{open.message && (
						<Grid classes={{ root: classes.subTitle }}>
							{open.message}
						</Grid>
					)}
					<FooterDialog
						open={open}
						handleTryAgain={handleTryAgain}
						handleHome={handleHome}
						handleWatchOrder={handleWatchOrder}
					/>
				</Grid>
			</Grid>
		</Dialog>
	);
};

export default DialogInformationTP;
